import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionList = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const [sectionList, setSectionList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [sectionIdSort, setSectionIdSort] = useState(null);
    const [principleNameSort, setPrincipleNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionName", "sectionId", "sectionInchargeName", "email", "contactNumber"];


    // const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSectionList();
    }, []);

    const getSectionList = async () => {
        try {
            let apiUrl = `/institute-report?institute_id=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl)
            setSectionList(response.data.data.sections);
        } catch (error) {
            setSectionList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSectionList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setSectionList(await searchArray("I", `/institute-report?institute_id=${instituteMasterId}`, searchKeys, searchValue.trim(), "sections"));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(sectionList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(sectionList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > sectionList.length) {
            endIndex = sectionList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(sectionList.slice(startIndex, endIndex));
    }, [sectionList, currPage, itemsPerPage]);

    useEffect(() => {
        if (sectionNameSort == true || sectionNameSort == false) {
            setSectionIdSort(null);
            setPrincipleNameSort(null);
        }
    }, [sectionNameSort])

    useEffect(() => {
        if (sectionIdSort == true || sectionIdSort == false) {
            setSectionNameSort(null);
            setPrincipleNameSort(null);
        }
    }, [sectionIdSort])

    useEffect(() => {
        if (principleNameSort == true || principleNameSort == false) {
            setSectionNameSort(null);
            setSectionIdSort(null);
        }
    }, [principleNameSort])

    return (
        <>
            {/* <Loader loading={loading} /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Section List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-section"></i> Section List </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Section ID
                                                                            <SortIcon sortState={sectionIdSort} setSortState={setSectionIdSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionId"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Section Incharge
                                                                            <SortIcon sortState={principleNameSort} setSortState={setPrincipleNameSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionInchargeName"} />
                                                                        </th>
                                                                        <th scope="col">Email</th>
                                                                        <th scope='col'>Contact No</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.sectionName}</td>
                                                                                        <td>{std.sectionId}</td>
                                                                                        <td>{std.sectionInchargeName}</td>
                                                                                        <td>{std.email}</td>
                                                                                        <td>{std.contactNumber}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Section Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={sectionList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionList;
